export default __webpack_public_path__ + "static/wotfard-light-webfont-fde08e381b27562e4ef4f23e3b8dbbb9.woff2";